import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root:{
    flexGrow: 1,
  },
  text:{
    fontSize: 30,
    textAlign: 'center',
    color:'#444444',
  },
})

class Sending extends Component{
  render(){
    const { classes } = this.props;
    return (

      <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >

      <div className={classes.root}>



        <div>
        <h3 className={classes.text}>結果を送信中です。</h3>
      <h3 className={classes.text}>ブラウザを閉じないでください。</h3>
        </div>
        <LinearProgress color="secondary" />
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Sending);



// WEBPACK FOOTER //
// ./src/components/quiz/Sending.js